import React, { useEffect, useState, useRef } from 'react';
interface FadeInSectionProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
}
export function FadeInSection({
  children,
  className = '',
  delay = 0
}: FadeInSectionProps) {
  const [isVisible, setVisible] = useState(false);
  const domRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1
    });
    const current = domRef.current;
    if (current) {
      observer.observe(current);
    }
    return () => {
      if (current) {
        observer.unobserve(current);
      }
    };
  }, []);
  return <div ref={domRef} className={`transition-all duration-700 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'} ${className}`} style={{
    transitionDelay: `${delay}ms`
  }} data-id="element-441">
      {children}
    </div>;
}